import React from 'react'
import { DataTable } from 'primereact/datatable';
import { Column, ColumnEvent, ColumnEditorOptions } from 'primereact/column';

type Props = {
  huffmanDictionary: Record<string, number>;
  setHuffmanDictionary: (input: any) => void;
}

interface HuffmanCode {
  code: string;
  symbol: string;
}

interface ColumnMeta {
  field: string;
  header: string;
}

const HuffmanCodeTable = ({ huffmanDictionary, setHuffmanDictionary }: Props) => {
  const huffmanCodes: HuffmanCode[] = Object.entries(huffmanDictionary).map(([code, symbol]) => ({
    code,
    symbol: symbol.toString(16).padStart(2, '0').toUpperCase(),
  }));

  console.log(huffmanCodes)

  const columns: ColumnMeta[] = [
    { field: 'code', header: 'Code' },
    { field: 'symbol', header: 'Symbol' },
  ];
  return (
    <div className="huffmanCodeTable">
      <h3>Huffman Codes</h3>
      <DataTable value={huffmanCodes} stripedRows scrollable scrollHeight="400px" editMode="cell" size="small">
        {columns.map(({ field, header }) => {
          return <Column key={field} field={field} header={header} />;
        })}
      </DataTable>
      {/* editor={(options) => cellEditor(options)} onCellEditComplete={onCellEditComplete} */}
    </div>
  )
}

export default HuffmanCodeTable